/**
 * The app's own instructions for finding the values the form asks for: what to have ready, the
 * steps in order, and any note the app's author left.
 */
const SetupGuide = ({ guide }) => {
  const items = Array.isArray(guide?.items) ? guide.items : [];
  const steps = items.filter((item) => item?.type === 'steps').flatMap((item) => (Array.isArray(item.items) ? item.items : []));
  const notices = items.filter((item) => item?.type === 'notice' && item.text);

  if (steps.length === 0 && notices.length === 0) {
    return null;
  }

  return (
    <section className="connections-guide" aria-labelledby="setup-guide">
      <h2 id="setup-guide" className="connections-guide__title">
        {guide.title || 'Where to find these details'}
      </h2>
      {guide.beforeYouBegin && <p className="connections-guide__lead">{guide.beforeYouBegin}</p>}
      <ol className="connections-guide__steps">
        {steps.map((step, index) => (
          <li key={`${index}-${step.title}`}>
            <span className="connections-guide__step-title">{step.title}</span>
            {step.description && <span className="connections-guide__step-text">{step.description}</span>}
          </li>
        ))}
      </ol>
      {notices.map((notice) => (
        <p key={notice.text} className="connections-guide__notice">
          {notice.text}
        </p>
      ))}
    </section>
  );
};

export default SetupGuide;
